import { Link } from 'react-router-dom';
import { DemoZoomCarousel } from '../components/DemoZoomCarousel';
import { t } from '../hooks/useT';

export function LandingPage() {
  return (
    <main className="page landing">
      <header className="hero">
        <h1 className="logo-mark">Dezoom</h1>
        <p className="tagline">{t('landing.tagline')}</p>

        <DemoZoomCarousel />

        <div className="cta-row">
          <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
          <Link to="/play?guest=1" className="btn secondary">{t('landing.ctaGuest')}</Link>
        </div>
        <Link to="/login" className="link-muted">{t('landing.login')}</Link>
        <Link to="/gallery" className="link-muted">{t('gallery.title')}</Link>
      </header>
    </main>
  );
}
